import { render, staticRenderFns } from "./EditorEditAssignmentModal.vue?vue&type=template&id=43dfc0a5&scoped=true&"
import script from "./EditorEditAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./EditorEditAssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dfc0a5",
  null
  
)

export default component.exports